import { useMemo } from "react";

import {
  createBrowserUrlParamsAdapter,
  UrlParamsAdapter,
} from "../../data/adapters/url-params.adapter";

export function useUrlParams(): UrlParamsAdapter {
  return useMemo(() => createBrowserUrlParamsAdapter(window), []);
}
